import React from "react";
import { Link } from "react-router-dom";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath } from "@/utils/common";

import { motion } from "framer-motion";

const GlobalTrade = React.memo(() => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };
  let redirectPath = '';
  if (user) {
    if (user?.role_slug?.slug === "SUP_ADM" || user?.role_slug?.slug === "VIEWER" || user?.role_slug?.slug === "END_USER" || user?.role_slug?.slug === "DEMO") {
      redirectPath = `/${getPrefix()}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`;
    }
    if (user?.role_slug?.slug === "PRE_KYC") {
      redirectPath = `/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`;
    }
  }

  return (
    <section className={`global-trade-wrape`}>
      <div className="container">
        <div className="head-text center">
          <motion.h2 className={`head center animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            Building Trusted Trade Networks Worldwide
          </motion.h2>

          <motion.p className={`text animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            Our presence across multiple countries ensures businesses can access global opportunities, trusted partners and seamless cross-border trade connections.
          </motion.p>
        </div>

        <motion.div className={`country-wrape animate-child`}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          custom={0.1}
          variants={fadeUpVariant}
        >
          <Link
            to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=US&searchBy=location`}
            className="country us"
            title="US"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}
          >
            <i className="flag "></i>
            <h6>US</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=CN&searchBy=location`} className="country china" title="CHINA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}
          >
            <i className="flag"></i>
            <h6>CHINA</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=IN&searchBy=location`} className="country india" title="INDIA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>INDIA</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=LK&searchBy=location`} className="country srilanka" title="SRI LANKA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>SRI LANKA</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=VN&searchBy=location`} className="country vietnam" title="VIETNAM"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>VIETNAM</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=AR&searchBy=location`} className="country argentina" title="ARGENTINA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>ARGENTINA</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=CL&searchBy=location`} className="country chile" title="CHILE"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>CHILE</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=CO&searchBy=location`} className="country columbia" title="COLUMBIA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>COLUMBIA</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=EC&searchBy=location`} className="country ecuador" title="ECUADOR"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>ECUADOR</h6>
            <p>Supplier/Logistics</p>
          </Link>
          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=MX&searchBy=location`} className="country mexico" title="MEXICO"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>MEXICO</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=PA&searchBy=location`} className="country panama" title="PANAMA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>PANAMA</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=PY&searchBy=location`} className="country paraguay" title="PARAGUAY"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>PARAGUAY</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=PH&searchBy=location`} className="country philippines" title="PHILIPPINES"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>PHILIPPINES</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=UY&searchBy=location`} className="country uruguay" title="URUGUAY"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>URUGUAY</h6>
            <p>Supplier/Logistics</p>
          </Link>

          {/* <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=VE&searchBy=location`} className="country venezuela" title="VENEZUELA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>VENEZUELA</h6>
            <p>Supplier/Logistics</p>
          </Link> */}

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=BD&searchBy=location`} className="country bangladesh" title="BANGLADESH"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>BANGLADESH</h6>
            <p>Supplier/Logistics</p>
          </Link>

          {/* <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=CM&searchBy=location`} className="country cameroon" title="CAMEROON"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>CAMEROON</h6>
            <p>Supplier/Logistics</p>
          </Link> */}

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=CR&searchBy=location`} className="country costarica" title="COSTARICA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>COSTARICA</h6>
            <p>Supplier/Logistics</p>
          </Link>

          {/* <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=GH&searchBy=location`} className="country ghana" title="GHANA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>GHANA</h6>
            <p>Supplier/Logistics</p>
          </Link> */}

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=KZ&searchBy=location`} className="country kazakhstan" title="KAZAKHSTAN"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>KAZAKHSTAN</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=BR&searchBy=location`} className="country brazil" title="BRAZIL"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>BRAZIL</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=EG&searchBy=location`} className="country egypt" title="EGYPT"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>EGYPT</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=AE&searchBy=location`} className="country uae" title="UAE"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>UAE</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=GB&searchBy=location`} className="country uk" title="UK"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>UK</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=SA&searchBy=location`} className="country saudi_Arabia" title="Saudi Arabia"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>Saudi Arabia</h6>
            <p>Supplier/Logistics</p>
          </Link>

          {/* <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=PK&searchBy=location`} className="country pakistan" title="PAKISTAN"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>PAKISTAN</h6>
            <p>Supplier/Logistics</p>
          </Link> */}

          {/* <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=TZ&searchBy=location`} className="country tanzania" title="TANZANIA"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>TANZANIA</h6>
            <p>Supplier/Logistics</p>
          </Link> */}

          <Link to={redirectPath ? redirectPath : `${publicRoutePaths.SEARCH_DETAIL.path}?type=logistic&country=TR&searchBy=location`} className="country turkey" title="TURKEY"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}>
            <i className="flag"></i>
            <h6>TURKEY</h6>
            <p>Supplier/Logistics</p>
          </Link>

          <Link
            to={redirectPath ? redirectPath : publicRoutePaths.SEARCH_DETAIL.path}
            className="country"
            title="EXPLORE MORE"
            target={redirectPath ? null : "_blank"}
            rel={redirectPath ? null : "noopener noreferrer"}
          >
            <h6 className="explore_more">
              EXPLORE <br /> MORE
            </h6>
            <span className="export">
              <span className="sprite"></span>
            </span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
})

export default GlobalTrade;
